import React from 'react'
import cn from 'classnames'
import { useWindowWidth } from '@react-hook/window-size'

import css from './layout.module.scss'

export default function(props) {
  const windowWidth = useWindowWidth()
  let img

  if (windowWidth < 768) {
    img = props.images.bg320
  }
  if (windowWidth >= 768 && windowWidth < 1200) {
    img = props.images.bg768
  }
  if (windowWidth >= 1200 && windowWidth < 1550) {
    img = props.images.bg1440
  }
  if (windowWidth >= 1550) {
    img = props.images.bg1920
  }
  
  return (
    <div className={css.blogLayout}>
      <div
        className={css.header}
        style={{backgroundImage: `url(${img})`}}
      >
        <div className='container'>
          <h1 className={css.title}>{props.title}</h1>
        </div>
      </div>
      {props.children}
    </div>
  )
}